export const getGroupPath = (id: string) => `/iam/groups/id/${id}`;
export const getNewGroupPath = () => `/iam/groups/nowe`;
